export const triviaCards = [
    {
        question: "what is Harry Potter's astrological sign?",
        answer: "Leo",
        answerShown: false,
        difficulty: "easy"
    },
    {
        question:"What is Dumbledore's little sister's name?",
        answer:"Ariana",
        answerShown: false,
        difficulty: "medium"
    },
    {
        question:"Who was SUPPOSED to murder Dumbledore?",
        answer: "Draco Malfoy",
        answerShown: false,
        difficulty: "hard"
    }
]